import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCasinoSearchValue } from '../../store/actions/casino.actions';
import { useLocation } from 'react-router-dom';

const CasinoSearch = () => {

    const dispatch = useDispatch();

    const { pathname } = useLocation();
    const { casinoSearchValue } = useSelector((state) => state.casino);

    const [searchVal, setSearchVal] = useState();

    const handleSearch = (e) => {
        let value = e.target.value;
        setSearchVal(value);
        dispatch(setCasinoSearchValue(e.target.value));
    };

    return (!pathname?.includes('/live-casino/categories') &&
        <div className='position-relative casino-search'>
            <input className="head-search" value={searchVal} onChange={handleSearch} placeholder="Search" />
            <img className="search-img" src="/images/search-icon.png" />
        </div>
    );
};

export default CasinoSearch;